import React, { useEffect, useState } from "react";
import "./styles/features.css";
import "./styles/font-awesome-ad.css";
import "./App.css";
const FeatureList = () => {
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    fetch("https://yellowgreen-crane-731584.hostingersite.com/api/app/features")
      .then((response) => response.json())
      .then((data) => {
        setFeatures(data.data);
      })
      .catch((error) => {
        console.error("Error fetching features:", error);
      });
  }, []);

  return (
    <div>
      {features.map((feature, index) => (
        <div className="feature" key={index}>
          <i className={feature.icon}></i>
          <label>{feature.name}</label>
        </div>
      ))}
    </div>
  );
};

export default FeatureList;
